import { BundlesModelDispatcher, ModalCta } from './editBundlePrice.vm';

export const getCta = (
  dispatch: BundlesModelDispatcher,
  isDraftMode: boolean,
  saving: boolean,
  publishing: boolean,
): Array<ModalCta> => {
  if (isDraftMode) {
    return [
      {
        label: 'Save',
        onClick: () => dispatch('savePriceChange'),
        color: 'primaryTonal',
        submitting: saving,
        disabled: saving || publishing,
      },
      {
        label: 'Publish',
        onClick: () => dispatch('publishBundle'),
        submitting: publishing,
        disabled: saving || publishing,
      },
    ];
  }
  return [
    {
      label: 'Save',
      onClick: () => dispatch('savePriceChange'),
      submitting: saving,
      disabled: saving,
    },
  ];
};
